"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const CheckIcon_1 = __importDefault(require("@portalterreno/react-ui-icons/CheckIcon"));
const StyledOption_1 = __importDefault(require("./StyledOption"));
function Option({ children, isSelected, selectedIcon = (0, jsx_runtime_1.jsx)(CheckIcon_1.default, { sx: { color: '#0068FF' } }), value, ...rest }) {
    return ((0, jsx_runtime_1.jsxs)(StyledOption_1.default, { isSelected: isSelected, ...rest, children: [children, " ", isSelected && selectedIcon] }));
}
exports.default = Option;
//# sourceMappingURL=Option.js.map